/* Clog — home a blocchi (vedi assets/clog-home.css).
   1. Filo di filamento: [data-filo] si disegna mentre la sezione attraversa lo schermo, con l'ugello sulla punta.
   2. Comparsa a cascata: [data-reveal] entra quando diventa visibile.
   3. Passaggio dall'apertura: il prodotto che l'hero sta mostrando "vola" nella sua scheda della vetrina.
   4. Fascia del catalogo: scorre da sola, si ferma quando la tocchi o ci passi sopra; su computer ha le frecce (4b).
   5. Blocchi a strati: ogni blocco resta fermo e il successivo gli sale sopra, con il bordo che si stampa a strati.
   6. Scorrimento a blocchi: ogni gesto (rotellina, tastiera) porta al blocco successivo o precedente; col dito la pagina segue il dito e al rilascio si aggancia.
   (Il blocco aziende ha il suo script: assets/clog-officina.js.)
   7. Caroselli su telefono: il gesto scorre o di lato o in verticale, mai in diagonale.
   Con "riduci movimento" attivo: niente movimenti automatici, tutto visibile e fermo. */
(function () {
  if (window.ClogHome) return;
  window.ClogHome = true;
  document.documentElement.classList.add('clog-js');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

  /* ---------- 1. filo ---------- */
  const fili = [];
  function setupFilo(el) {
    const path = el.querySelector('.cfilo__path'), noz = el.querySelector('.cfilo__ugello'), svg = el.querySelector('svg');
    if (!path || !svg) return;
    const len = path.getTotalLength(), vb = svg.viewBox.baseVal;
    path.style.strokeDasharray = len; path.style.strokeDashoffset = still ? 0 : len;
    fili.push({ el, path, noz, len, vb, last: -1 });
  }
  function drawFili() {
    const vh = window.innerHeight;
    fili.forEach(f => {
      const r = f.el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      // 0 quando il filo entra dal basso, 1 quando arriva a un terzo dello schermo
      const p = still ? 1 : clamp((vh - r.top) / (vh * 0.62), 0, 1);
      if (Math.abs(p - f.last) < 0.002) return; f.last = p;
      f.path.style.strokeDashoffset = f.len * (1 - p);
      f.el.classList.toggle('is-drawing', p > 0.01 && p < 0.995);
      if (f.noz) {
        const pt = f.path.getPointAtLength(f.len * p);
        f.noz.style.transform = `translate(${(pt.x - f.vb.x) / f.vb.width * r.width}px, ${(pt.y - f.vb.y) / f.vb.height * r.height}px)`;
      }
      const piatto = f.el.closest('.ccat') && f.el.closest('.ccat').querySelector('.ccat__piatto');
      if (piatto) piatto.style.setProperty('--p', p);
    });
  }

  /* ---------- 2. comparsa ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
  }), { rootMargin: '0px 0px -8% 0px' }) : null;

  /* ---------- 3. dall'apertura alla scheda ---------- */
  function setupVolo(sec) {
    const hero = document.querySelector('.chero');
    if (!hero || still || !io) return;
    // sfumatura: il colore di fondo dell'apertura continua nella vetrina
    const syncBg = () => sec.style.setProperty('--cprod-from', getComputedStyle(hero).backgroundColor);
    syncBg(); new MutationObserver(syncBg).observe(hero, { attributes: true, attributeFilter: ['class', 'style'] });
    setInterval(() => { const r = hero.getBoundingClientRect(); if (r.bottom > 0) syncBg(); }, 1200);
    // parte ogni volta che si scende dall'apertura alla vetrina (si riarma quando si torna su)
    let done = false;
    const trig = new IntersectionObserver(es => {
      es.forEach(e => {
        if (e.isIntersecting) { if (!done && hero.getBoundingClientRect().bottom > -window.innerHeight) { done = true; vola(hero, sec); } }
        else if (e.boundingClientRect.top > 0) done = false;
      });
    }, { rootMargin: '0px 0px -35% 0px' });
    trig.observe(sec.querySelector('.cprod__grid') || sec);
  }
  function vola(hero, sec) {
    const handle = hero.dataset.handle, snap = hero.clogSnap && hero.clogSnap();
    const card = handle && sec.querySelector(`[data-handle="${handle}"]`);
    if (!card) return;
    const media = card.querySelector('.cprod__media'), grid = sec.querySelector('.cprod__grid');
    // su telefono le schede scorrono di lato: porta in vista quella giusta
    if (grid && grid.scrollWidth > grid.clientWidth + 4) {
      const li = card.closest('.cprod__item');
      grid.scrollTo({ left: li.offsetLeft - (grid.clientWidth - li.offsetWidth) / 2, behavior: 'auto' });
    }
    if (!snap || !media) { media && media.classList.add('is-landed'); return; }
    const stage = hero.querySelector('[data-stage]'), a = stage.getBoundingClientRect(), b = media.getBoundingClientRect();
    // se l'apertura e' gia' uscita dallo schermo, il prodotto parte dal bordo alto
    const from = a.bottom > 40 ? a : { left: b.left, top: -b.height * 0.6, width: b.width, height: b.height };
    const img = new Image(); img.src = snap; img.alt = ''; img.className = 'clog-volo';
    img.style.width = from.width + 'px'; img.style.height = from.height + 'px';
    img.style.objectFit = 'contain';
    document.body.appendChild(img);
    // il prodotto occupa circa il 70% della scheda
    const k = Math.min(b.width / from.width, b.height / from.height) * 0.92;
    const tx = b.left + (b.width - from.width * k) / 2, ty = b.top + (b.height - from.height * k) / 2;
    const anim = img.animate([
      { transform: `translate(${from.left}px, ${from.top}px) scale(1)`, opacity: 1 },
      { transform: `translate(${tx}px, ${ty}px) scale(${k})`, opacity: 1, offset: .82 },
      { transform: `translate(${tx}px, ${ty}px) scale(${k})`, opacity: 0 }
    ], { duration: 1100, easing: 'cubic-bezier(.45,.05,.2,1)' });
    const y0 = window.scrollY;
    const follow = () => { const dy = window.scrollY - y0; if (dy) { img.style.translate = `0 ${-dy}px`; } };
    window.addEventListener('scroll', follow, { passive: true });
    anim.finished.then(() => { media.classList.add('is-landed'); }).catch(() => {}).finally(() => { img.remove(); window.removeEventListener('scroll', follow); });
  }

  /* ---------- 4. fascia del catalogo ---------- */
  function setupCatalogo(sec) {
    const track = sec.querySelector('.ccat__track'); if (!track) return;
    const items = [...track.children]; if (items.length < 2) return;
    // copie per il giro continuo (nascoste agli screen reader e alla tastiera): almeno una in piu' dello schermo, anche con pochi prodotti
    const copia = () => items.forEach(li => { const c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.querySelectorAll('a').forEach(a => a.tabIndex = -1); c.dataset.copy = '1'; track.appendChild(c); });
    const giro = () => track.children[items.length].offsetLeft - items[0].offsetLeft;      // larghezza di una serie
    const riempi = () => { while (track.scrollWidth - giro() < track.clientWidth + 20 && track.children.length < items.length * 8) copia(); };
    copia(); riempi(); window.addEventListener('resize', riempi);
    track.clogGiro = giro;
    if (still) return;
    let paused = false, visible = false, resumeT = null, last = 0, acc = 0;
    const speed = () => (window.innerWidth < 750 ? 26 : 34);          // pixel al secondo
    const verso = track.dataset.verso === '-1' ? -1 : 1;               // -1: scorre verso destra (i personalizzati, opposti al catalogo)
    if (verso < 0) requestAnimationFrame(() => { track.scrollLeft = giro(); });
    const half = giro;
    const pause = () => { paused = true; clearTimeout(resumeT); };
    const resume = (ms) => { clearTimeout(resumeT); resumeT = setTimeout(() => { paused = false; }, ms == null ? 2200 : ms); };
    track.clogPausa = pause; track.clogRiprendi = resume;              // usati dalle frecce (4b)
    track.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') pause(); });
    track.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') resume(400); });
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', () => resume(), { passive: true });
    track.addEventListener('focusin', pause); track.addEventListener('focusout', () => resume());
    track.addEventListener('wheel', () => { pause(); resume(); }, { passive: true });
    track.addEventListener('scroll', () => {                         // giro continuo anche quando scorri a mano
      const h = half(); if (track.scrollLeft >= h) track.scrollLeft -= h; else if (track.scrollLeft <= 0 && (paused || verso < 0)) track.scrollLeft += h;
    }, { passive: true });
    new IntersectionObserver(es => { visible = es.some(e => e.isIntersecting); }).observe(track);
    const step = now => {
      requestAnimationFrame(step);
      const dt = last ? Math.min(64, now - last) : 16; last = now;
      if (paused || !visible || document.visibilityState !== 'visible') return;
      acc += speed() * dt / 1000;
      const px = Math.floor(acc); if (!px) return; acc -= px;
      const h = half(); let x = track.scrollLeft + px * verso; if (x >= h) x -= h; else if (x <= 0) x += h; track.scrollLeft = x;
    };
    requestAnimationFrame(step);
  }

  /* ---------- 4b. frecce della fascia (solo computer con mouse; su telefono e tablet restano nascoste dal CSS) ---------- */
  // Ogni clic sposta la fascia di quante schede stanno in tre quarti di schermo, con il giro continuo come lo scorrimento automatico.
  // Stanno nell'intestazione del blocco, accanto a "Vedi tutti". Mentre il mouse e' sulla freccia la fascia resta ferma.
  function setupFrecce(sec) {
    const track = sec.querySelector('.ccat__track'); if (!track || !track.clogGiro || track.children.length < 2) return;
    const box = document.createElement('div'); box.className = 'ccat__frecce';
    const btn = (dir, label) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'ccat__freccia ccat__freccia--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      b.addEventListener('click', () => scorri(dir));
      b.addEventListener('pointerenter', () => track.clogPausa && track.clogPausa());
      b.addEventListener('pointerleave', () => track.clogRiprendi && track.clogRiprendi(400));
      b.addEventListener('focus', () => track.clogPausa && track.clogPausa());
      b.addEventListener('blur', () => track.clogRiprendi && track.clogRiprendi());
      return b;
    };
    box.append(btn(-1, track.dataset.prev || 'Precedenti'), btn(1, track.dataset.next || 'Successivi'));
    // accanto a "Vedi tutti", in alto a destra (dal 30/10/2026: sopra la fascia coprivano le schede)
    const head = sec.querySelector('.ccat__head'); if (!head) return;
    const azioni = document.createElement('div'); azioni.className = 'ccat__azioni';
    const tutti = head.querySelector('.ccat__all');
    azioni.append(box); if (tutti) azioni.append(tutti);
    head.append(azioni);
    let corsa = 0;
    function scorri(dir) {
      const items = track.children; const passo = items[1].offsetLeft - items[0].offsetLeft;
      const n = Math.max(1, Math.floor(track.clientWidth * 0.75 / passo)), dist = n * passo * dir;
      const id = ++corsa, T = still ? 0 : 520, t0 = performance.now(); let fatto = 0;
      const ease = k => 1 - Math.pow(1 - k, 3);
      const muovi = now => {
        if (id !== corsa) return;
        const k = T ? Math.min(1, (now - t0) / T) : 1, d = dist * ease(k) - fatto; fatto += d;
        const h = track.clogGiro(); let x = track.scrollLeft + d; if (x >= h) x -= h; else if (x < 0) x += h; track.scrollLeft = x;
        if (k < 1) requestAnimationFrame(muovi);
      };
      requestAnimationFrame(muovi);
    }
  }

  /* ---------- 5. blocchi a strati ---------- */
  // ogni blocco della home resta fermo mentre il successivo gli sale sopra; il bordo di chi sale si "stampa" a strati
  const strati = [];
  function setupStrati() {
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main || still || !main.querySelector('.cprod, .ccat, .caz')) return;
    const secs = [...main.children].filter(el => el.classList.contains('shopify-section') && el.offsetHeight > 0);
    if (secs.length < 2) return;
    const bodyBg = getComputedStyle(document.body).backgroundColor || '#fff';
    secs.forEach((s, i) => {
      const inner = [...s.children].find(c => !/^(LINK|SCRIPT|STYLE)$/.test(c.tagName));   // salta il CSS/JS incluso dalla sezione
      let bg = inner ? getComputedStyle(inner).backgroundColor : '';
      if (!bg || bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg)) bg = bodyBg;
      s.classList.add('clog-strato'); s.style.zIndex = i + 1; s.style.setProperty('--strato-bg', bg);
      let layers = [];
      if (i > 0) {
        const b = document.createElement('div'); b.className = 'clog-bordo'; b.setAttribute('aria-hidden', 'true');
        b.innerHTML = '<i></i><i></i><i></i><i></i>'; s.prepend(b); layers = [...b.children].reverse(); // dal basso in alto
      }
      strati.push({ s, layers, top: 0, h: 0, c: -1, e: -1 });
    });
    // 6. segnaposto invisibile prima di ogni blocco (sui blocchi stessi no: sono "sticky" e si spostano)
    const segni = secs.slice(1).map(s => { const a = document.createElement('div'); a.className = 'clog-snap'; a.setAttribute('aria-hidden', 'true'); s.before(a); return a; });
    setupAggancio(segni);
    document.documentElement.classList.add('clog-strati');
    misuraStrati();
    window.addEventListener('resize', misuraStrati); window.addEventListener('load', misuraStrati);
    if ('ResizeObserver' in window) { const ro = new ResizeObserver(() => misuraStrati()); secs.forEach(s => ro.observe(s)); }
  }
  function misuraStrati() {
    const vh = window.innerHeight;
    strati.forEach((st, i) => {
      st.h = st.s.offsetHeight; st.top = Math.min(0, vh - st.h);
      st.s.style.top = st.top + 'px';
      // se l'ultimo blocco e' basso non coprirebbe il penultimo: il penultimo scorre normalmente
      const n = strati.length, ultimoBasso = strati[n - 1].s.offsetHeight < vh * .7;
      st.libero = i === n - 1 || (i === n - 2 && ultimoBasso);
      st.s.classList.toggle('clog-strato--libero', st.libero);
      st.s.style.transformOrigin = `50% ${Math.round(-st.top + Math.min(vh, st.h) / 2)}px`;
    });
    drawStrati();
  }
  function drawStrati() {
    if (!strati.length) return;
    const vh = window.innerHeight;
    strati.forEach((st, i) => {
      const r = st.s.getBoundingClientRect();
      // bordo a strati: appena il blocco entra si stampa tutto da solo (prima gli strati in basso, a zig-zag come l'ugello; tempi in clog-home.css).
      // Dal 30/10/2026: prima seguiva lo scorrimento e, fermandosi a meta', restava un gradino tra un blocco e l'altro.
      if (st.layers.length) {
        const e = r.top < vh - 8 ? 1 : (r.top > vh + 40 ? 0 : st.e);
        if (e !== st.e) { st.e = e; st.s.classList.toggle('is-stampato', e === 1); }
      }
      // quanto il blocco successivo copre questo
      const nx = strati[i + 1]; let c = 0;
      if (nx && !st.libero) { const fondo = st.top + st.h; c = clamp((fondo - nx.s.getBoundingClientRect().top) / Math.max(1, fondo), 0, 1); }
      if (Math.abs(c - st.c) > 0.002) {
        st.c = c; st.s.style.setProperty('--c', c.toFixed(3));
        st.s.classList.toggle('is-coperto', c > 0.003); st.s.classList.toggle('is-sepolto', c > 0.995);
      }
    });
  }

  /* ---------- 6. scorrimento a blocchi ---------- */
  // Come i siti "a pagine intere": ogni gesto (uno scatto di rotellina, una passata col dito, frecce/pagina giu'/spazio)
  // porta all'inizio del blocco successivo o precedente, appena sotto l'intestazione, con un'animazione.
  // Un blocco piu' alto dello schermo si percorre a pezzi (al massimo 80% dello schermo per gesto) finche' se ne vede la fine, poi si passa al successivo
  // (dal 29/10/2026: prima solo se era alto piu' di una volta e mezza lo schermo, e su telefono il pulsante in fondo all'apertura restava irraggiungibile).
  // Dopo l'ultimo blocco (fascia finale e pie' di pagina) lo scorrimento torna normale.
  // Gesti di lato (caroselli, modello 3D dell'apertura) e campi di testo non vengono toccati.
  function setupAggancio(segni) {
    if (still || !segni.length) return;
    const DURATA = 750;
    let anim = false, ultimoWheel = 0, bloccoWheel = false, t0 = null;
    const testata = () => { const h = document.querySelector('.section-header, sticky-header, header');
      if (!h) return 0; const pos = getComputedStyle(h).position; return (pos === 'sticky' || pos === 'fixed') ? Math.round(h.getBoundingClientRect().height) : 0; };
    const inizi = () => { const t = testata(); return [0].concat(segni.map(a => Math.max(0, Math.round(a.getBoundingClientRect().top + window.scrollY - t)))); };
    // destinazione per un gesto in quella direzione, oppure null = lascia scorrere normalmente
    function meta(dir) {
      const y = window.scrollY, vh = window.innerHeight, P = inizi(), ultimo = P[P.length - 1];
      const max = document.documentElement.scrollHeight - vh;
      if (dir > 0) {
        if (y >= ultimo - 4) return null;
        const n = P.find(v => v > y + 4); if (n === undefined) return null;
        // se la fine del blocco corrente e' ancora sotto lo schermo, prima si mostra quella (a pezzi dell'80% dello schermo)
        const resto = n + testata() - y - vh;
        return Math.min(max, resto > 24 ? y + Math.min(vh * .8, resto) : n);
      }
      if (y > ultimo + 4) return null;
      const prec = P.filter(v => v < y - 4).pop(); if (prec === undefined) return null;
      return y - prec > vh * 1.5 ? y - vh * .8 : prec;
    }
    const easeIO = k => (k < .5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2);
    let corsa = 0;                                                    // ogni nuova animazione ferma quella in corso
    function vai(dest, durata) {
      const da = window.scrollY, dist = dest - da, id = ++corsa; if (Math.abs(dist) < 2) { anim = false; return; }
      anim = true; const inizio = performance.now(), T = durata || DURATA;
      const passo = now => { if (id !== corsa) return; const k = Math.min(1, (now - inizio) / T); window.scrollTo(0, da + dist * easeIO(k));
        if (k < 1) requestAnimationFrame(passo); else setTimeout(() => { if (id === corsa) anim = false; }, 60); };
      requestAnimationFrame(passo);
    }
    const ferma = () => { corsa++; anim = false; };
    const daEscludere = el => el && el.closest && el.closest('input, textarea, select, [contenteditable], .drawer, details[open] .header__submenu, .menu-drawer, cart-drawer, .modal');
    // rotellina e trackpad: un gesto = un blocco (lo slancio del trackpad viene ignorato finche' non si ferma)
    window.addEventListener('wheel', e => {
      if (e.ctrlKey || Math.abs(e.deltaY) < Math.abs(e.deltaX) || daEscludere(e.target)) return;
      const now = performance.now(), nuovo = now - ultimoWheel > 220; ultimoWheel = now;
      if (anim || (bloccoWheel && !nuovo)) { if (anim || meta(Math.sign(e.deltaY)) !== null) e.preventDefault(); return; }
      bloccoWheel = false;
      if (Math.abs(e.deltaY) < 3) return;
      const d = meta(Math.sign(e.deltaY)); if (d === null) return;
      e.preventDefault(); bloccoWheel = true; vai(d);
    }, { passive: false });
    // dito: la pagina segue il dito; al rilascio finisce la corsa fino al blocco successivo (o torna indietro se il gesto e' stato corto)
    const max = () => document.documentElement.scrollHeight - window.innerHeight;
    window.addEventListener('touchstart', e => {
      if (e.touches.length !== 1 || daEscludere(e.target)) { t0 = null; return; }
      if (anim) ferma();                                              // un dito durante l'animazione la prende al volo
      const y = window.scrollY, gestito = meta(1) !== null || meta(-1) !== null;
      t0 = gestito ? { x: e.touches[0].clientX, y: e.touches[0].clientY, s0: y, asse: null, dest: undefined, ly: e.touches[0].clientY, lt: e.timeStamp, v: 0 } : null;
    }, { passive: true });
    window.addEventListener('touchmove', e => {
      if (!t0) return;
      const ty = e.touches[0].clientY, dx = e.touches[0].clientX - t0.x, dy = ty - t0.y;
      if (!t0.asse) {
        if (Math.abs(dx) <= 8 && Math.abs(dy) <= 8) { if (Math.abs(dy) >= Math.abs(dx) && e.cancelable) e.preventDefault(); return; }
        t0.asse = Math.abs(dy) > Math.abs(dx) ? 'y' : 'x';
        if (t0.asse === 'x') { t0 = null; return; }                  // gesto di lato: ci pensa il carosello
        t0.dest = meta(dy < 0 ? 1 : -1);
      }
      if (e.cancelable) e.preventDefault();
      const dt = Math.max(1, e.timeStamp - t0.lt); t0.v = .7 * ((ty - t0.ly) / dt) + .3 * t0.v; t0.ly = ty; t0.lt = e.timeStamp;
      let y = t0.s0 - dy;
      if (t0.dest !== null) y = clamp(y, Math.min(t0.s0, t0.dest), Math.max(t0.s0, t0.dest));   // non oltre il blocco di arrivo
      window.scrollTo(0, clamp(y, 0, max()));
    }, { passive: false });
    const rilascio = () => {
      if (!t0 || t0.asse !== 'y') { t0 = null; return; }
      const { s0, dest, v } = t0; t0 = null; const y = window.scrollY;
      if (dest === null) { vai(clamp(y - v * 320, 0, max()), 500); return; }   // zona libera (fondo pagina): un po' di slancio
      const fatto = Math.abs(y - s0) / Math.max(1, Math.abs(dest - s0)), versoGiusto = Math.sign(-v) === Math.sign(dest - s0);
      const arriva = fatto > .25 || (versoGiusto && Math.abs(v) > .35);
      vai(arriva ? dest : s0, arriva ? 380 + 320 * (1 - fatto) : 320);
    };
    window.addEventListener('touchend', rilascio, { passive: true }); window.addEventListener('touchcancel', rilascio, { passive: true });
    // tastiera
    window.addEventListener('keydown', e => {
      if (daEscludere(e.target) || e.altKey || e.ctrlKey || e.metaKey) return;
      const giu = ['ArrowDown', 'PageDown'].includes(e.key) || (e.key === ' ' && !e.shiftKey), su = ['ArrowUp', 'PageUp'].includes(e.key) || (e.key === ' ' && e.shiftKey);
      if (!giu && !su) return;
      if (anim) { e.preventDefault(); return; }
      const d = meta(giu ? 1 : -1); if (d === null) return;
      e.preventDefault(); vai(d);
    });
  }

  /* ---------- 7. caroselli: su telefono si scorre o in orizzontale o in verticale, mai in diagonale ---------- */
  // Il primo movimento decide l'asse. Verticale: il carosello si blocca e scorre la pagina.
  // Orizzontale: la pagina si blocca e il carosello lo muoviamo noi col dito, poi si aggancia alla scheda piu' vicina.
  function bloccaAsse(el) {
    let x0 = 0, y0 = 0, sl0 = 0, asse = null, lx = 0, lt = 0, v = 0, snapT = null;
    const aggancia = el.classList.contains('cprod__grid');
    el.addEventListener('touchstart', e => {
      const t = e.touches[0]; x0 = lx = t.clientX; y0 = t.clientY; sl0 = el.scrollLeft; lt = e.timeStamp; v = 0; asse = null;
    }, { passive: true });
    el.addEventListener('touchmove', e => {
      if (e.touches.length > 1) return;
      const t = e.touches[0], dx = t.clientX - x0, dy = t.clientY - y0;
      if (!asse && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        asse = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (asse === 'y') el.style.overflowX = 'hidden';
        else { clearTimeout(snapT); el.style.scrollSnapType = 'none'; sl0 = el.scrollLeft + dx; }
      }
      if (asse !== 'x') return;
      if (e.cancelable) e.preventDefault();
      const dt = Math.max(1, e.timeStamp - lt); v = .8 * ((t.clientX - lx) / dt) + .2 * v; lx = t.clientX; lt = e.timeStamp;
      let x = sl0 - dx;
      if (!aggancia) { const h = el.clogGiro ? el.clogGiro() : el.scrollWidth / 2; if (x >= h) { x -= h; sl0 -= h; } else if (x < 0) { x += h; sl0 += h; } }   // giro continuo
      el.scrollLeft = x;
    }, { passive: false });
    const fine = () => {
      if (asse === 'y') el.style.overflowX = '';
      if (asse === 'x') {
        if (aggancia) {
          const dest = el.scrollLeft - v * 220, items = [...el.children];
          const pad = parseFloat(getComputedStyle(el).scrollPaddingLeft) || 0;
          let best = items[0], bd = Infinity;
          const er = el.getBoundingClientRect().left, pos = li => li.getBoundingClientRect().left - er + el.scrollLeft - pad;
          items.forEach(li => { const d = Math.abs(pos(li) - dest); if (d < bd) { bd = d; best = li; } });
          el.scrollTo({ left: pos(best), behavior: 'smooth' });
        } else el.scrollBy({ left: -v * 280, behavior: 'smooth' });
        snapT = setTimeout(() => { el.style.scrollSnapType = ''; }, 600);
      }
      asse = null;
    };
    el.addEventListener('touchend', fine, { passive: true }); el.addEventListener('touchcancel', fine, { passive: true });
  }

  /* ---------- avvio ---------- */
  function init() {
    document.querySelectorAll('[data-filo]').forEach(setupFilo);
    document.querySelectorAll('[data-reveal]').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
    document.querySelectorAll('.cprod[data-volo]').forEach(setupVolo);
    document.querySelectorAll('.ccat').forEach(setupCatalogo);
    document.querySelectorAll('.ccat').forEach(setupFrecce);
    setupStrati();
    document.querySelectorAll('.cprod__grid, .ccat__track').forEach(bloccaAsse);
    let ticking = false;
    const onScroll = () => { if (ticking) return; ticking = true; requestAnimationFrame(() => { ticking = false; drawFili(); drawStrati(); }); };
    window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    drawFili();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
